import { styled, Typography } from "@mui/material";

export const StyledTitle = styled(Typography)(({ theme: { typography } }) => ({
  fontWeight: typography.fontWeightBold,
}));

export const StyledText = styled(Typography)(({ theme: { palette } }) => ({
  color: palette.grey["700"],
}));
